import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import { Box, Card, CardProps, Stack, Typography, styled } from "@mui/material";

const CustomCard = styled(Card)<CardProps>(({ theme }) => ({
  position: "relative",
  width: "100%",
  marginTop: theme.spacing(3.5),
  padding: theme.spacing(3),
  overflow: "hidden",
  textAlign: "center",
  border: "1px solid rgba(255,255,255,0.55)",
  borderRadius: 24,
  background: "linear-gradient(145deg, rgba(255,255,255,0.98), rgba(240,247,255,0.94))",
  boxShadow: "0 22px 50px rgba(3, 23, 103, 0.24)",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: "0 0 auto 0",
    height: 5,
    background: "linear-gradient(90deg, #00D9FF, #014DDF, #6C5CE7)",
  },
  [theme.breakpoints.down("md")]: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.3, 1.5),
    borderRadius: 14,
    textAlign: "left",
    boxShadow: "0 8px 24px rgba(3, 23, 103, 0.16)",
    ".student-profile-label, .avatar": { display: "none" },
    ".student-name": {
      fontSize: 14,
      lineHeight: 1.35,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    ".student-dni": { paddingTop: 0, fontSize: 12.5 },
  },
}));

const StudentCard = ({ data }: any) => (
  <CustomCard elevation={0}>
    <Stack
      className="student-profile-label"
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={0.75}
      sx={{ color: "primary.main" }}
    >
      <PersonRoundedIcon sx={{ fontSize: 18 }} />
      <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" }}>
        Mi perfil Focus
      </Typography>
    </Stack>

    <Box
      className="avatar"
      sx={{
        width: 112,
        height: 112,
        mx: "auto",
        my: 2,
        p: 1,
        borderRadius: "50%",
        background: "linear-gradient(135deg, #00D9FF, #014DDF)",
        boxShadow: "0 10px 26px rgba(1,77,223,0.2)",
      }}
    >
      <Box component="img" src="./icons/avatar.png" alt="" sx={{ width: "100%", height: "100%", display: "block" }} />
    </Box>

    <Typography
      className="student-name"
      title={data.name_complet_student}
      sx={{
        color: "#17254B",
        fontSize: 19,
        fontWeight: 700,
        lineHeight: 1.4,
        textTransform: "capitalize",
      }}
    >
      {data.name_complet_student.toLowerCase()}
    </Typography>
    <Stack
      className="student-dni"
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={0.75}
      sx={{ pt: 1.25, color: "text.secondary", fontSize: 15, fontWeight: 600 }}
    >
      <BadgeRoundedIcon aria-hidden="true" sx={{ color: "primary.main", fontSize: 22 }} />
      <Box component="span">DNI {data.dni_student}</Box>
    </Stack>
  </CustomCard>
);

export default StudentCard;
